import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from 'src/api/mineCraftApi';
import minecraftUrls from "src/configs/mine_craft/minecraftUrls";
import { RewardInterface } from 'src/store/mine_craft/rewardsSlice';

const processStrategy = (value: any) => {
  return {
    ...value,
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url)
  };
}

export const rewardsEntity = new schema.Entity(
  'rewards',
  {},
  {
    processStrategy
  }
);

export const rewardEntity = new schema.Entity(
  'reward',
  {},
  {
    processStrategy
  }
);

const fetchRewardsCollection = async (url: string, params: object = {}) => {
  const response    = await mineCraftApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      rewards: { [key: string]: RewardInterface };
    }
  >(response.data.rewards, [rewardsEntity]);

  return {
    rewards: normalized.entities?.rewards || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      reward: RewardInterface;
    }
  >(response.data.reward, rewardEntity);
  return normalized.entities;
}

export const fetchRewards = createAsyncThunk(
  'rewards/fetchRewards',
  async (params: object = {}) => fetchRewardsCollection('/onesky/rewards', params)
);

export const fetchReward = createAsyncThunk(
  'rewards/fetchReward',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/rewards/${id}`);
    return normalizeInstance(response);
  }
);

export const createReward = createAsyncThunk(
  'rewards/createReward',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/rewards`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateReward = createAsyncThunk(
  'rewards/updateReward',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/rewards/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyReward = createAsyncThunk(
  'rewards/destroyReward',
  async (id: number) => {
    await mineCraftApi.delete(`/onesky/rewards/${id}`);
    return { id: id };
  }
);
